import { ICamera, IProject, IUser } from '@api/models';
import { IProgressLineActivity } from '@api/models/analytics.model';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface ProgressLineActivityListProps {
    isLoading: boolean;
    activityData: IProgressLineActivity[];
}

const ProgressLineActivityList = ({ isLoading, activityData }: ProgressLineActivityListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={activityData}
            columns={[
                { header: 'ID' },
                { header: 'Date' },
                { header: 'Caption' },
                { header: 'Media' },
                { header: 'Camera' },
                { header: 'Project' },
                { header: 'User' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{row._id}</Table.Cell>

                    <Table.Cell>{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</Table.Cell>

                    <Table.Cell>{row.caption || '—'}</Table.Cell>

                    <Table.Cell>
                        {/* <a className="text-primary underline" href={row.file} target="_blank" rel="noopener noreferrer">
                            {row.mediaType.toUpperCase()}
                        </a> */}
                        {row.mediaType.toUpperCase()}
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.camera as ICamera).client}/projects/${
                                (row.camera as ICamera).project
                            }/cameras/${(row.camera as ICamera)._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.camera as ICamera)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.user as IUser).client}/projects/${
                                (row.project as IProject)._id
                            }/project-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.project as IProject)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.user as IUser).client}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser)?.name}
                        </Link>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default ProgressLineActivityList;
